import { NgOptimizedImage } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import {
  SelectionButtonComponent,
  UnselectionButtonComponent,
  WinCardComponent,
} from '@shared/components/challenges/elements';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CampaignPhase } from '@shared/constants';
import {
  ElementDirective,
  TooltipDirective,
  TooltipIfTruncatedDirective,
} from '@shared/directives';
import { StepChallenge } from '@shared/factory';
import { StepChallengeVariant1Config } from '@shared/models';
import { AmountPipe } from '@shared/pipes';

import { StepBaseClass } from '../step.base.class';

import { ProgressSectionComponent } from './progress-section/progress-section.component';

@Component({
  selector: 'b2c-variant1',
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [
    AmountPipe,
    IconComponent,
    ElementDirective,
    WinCardComponent,
    NgOptimizedImage,
    TooltipDirective,
    SelectionButtonComponent,
    ProgressSectionComponent,
    UnselectionButtonComponent,
    TooltipIfTruncatedDirective,
  ],
})
export class Variant1Component extends StepBaseClass {
  /**
   * Render the card the way a shopper sees it once the challenge is selected —
   * its steps on show — while the challenge is in fact still unselected, and
   * drop the selection button. Set by the onboarding swipe deck, where the
   * deck's own pass/select buttons and the swipe gesture do the selecting.
   */
  previewSelected = input<boolean>(false);

  challenge = input.required<StepChallenge>();
  config = input.required<StepChallengeVariant1Config>();

  index = input<number>(0);
  loadBannerInPriority = input<boolean>(false);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  withShadow = input<boolean>(true);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  /**
   * logo is displayed if there is no banner
   */
  readonly shouldShowLogo = computed(() => {
    const currentChallenge = this.challenge();
    const hasBanner = currentChallenge.hasBanner();
    return !hasBanner;
  });
}
